import { render, staticRenderFns } from "./ModalDeliveryRegister.vue?vue&type=template&id=72490493&scoped=true"
import script from "./ModalDeliveryRegister.vue?vue&type=script&lang=ts"
export * from "./ModalDeliveryRegister.vue?vue&type=script&lang=ts"
import style0 from "./ModalDeliveryRegister.vue?vue&type=style&index=0&id=72490493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72490493",
  null
  
)

export default component.exports